import React, { FC } from 'react'

import { RouterLink } from 'components/designSystem/Link/RouterLink'
import { indexPath } from 'components/paths'

import { LogoSwitch } from './LogoSwitch'

export const LogoLink: FC = () => {
  return (
    <RouterLink to={indexPath} data-name="logo-action">
      <LogoSwitch />
    </RouterLink>
  )
}
